module.exports = __webpack_public_path__ + "img/2.5bd53c8b.jpg";